import {
  format, differenceInDays, isBefore,
} from 'date-fns';
import useTranslation from './translation-utils';

export const formatDate = (date, dateFormat = 'MMM dd, yyyy') => format(new Date(date), dateFormat);

export const formatTime = (date) => format(new Date(date), 'hh:mm a');

export const getDiffInDays = (targetDate) => {
  const [getTranslation] = useTranslation();
  const today = new Date();
  const date = new Date(targetDate);
  if (isBefore(today, date)) {
    return `${differenceInDays(date, today)} ${getTranslation('DAYS_LEFT')}`;
  }
  return `${differenceInDays(today, date)} ${getTranslation('DAYS_AGO')}`;
};
